import template from './uc-milestones-page.html.twig';
import './uc-milestones-page.scss';

// Vendor+plugin-prefixed name — see the matching comment in
// components/uc-element-sorter/index.js for why (global registry collision).
Shopware.Component.register('sellops-uc-milestones-page', {
    template,

    methods: {
        goToConfig() {
            this.$router.push({ name: 'sellops.ultimate.cart.config' });
        },
    },
});
